import { useMemo } from 'react';

import { ColDef } from 'ag-grid-community';

import { useFeatureFlag } from '@/hooks/useFeatureFlag';

import { OpuSearchSelectButton } from '../components/OpuSearchSelectButton';

export const useColumnDefs = (): ColDef[] => {
  const aspirationSelectColumnStayAtFront = useFeatureFlag(
    'Aspiration_Select_Column_Stay_At_Front',
  );
  return useMemo<ColDef[]>(() => [
    {
      cellRenderer: OpuSearchSelectButton,
      width: 90,
      suppressMovable: aspirationSelectColumnStayAtFront,
      lockPosition: aspirationSelectColumnStayAtFront,
      cellClassRules: {
        glass: (params) => {
          if (params.data?.embCompleteOrder > 0) {
            return true;
          }
          return false;
        },
      },
    },
    { field: 'aspirationTime', headerName: 'Aspiration Time', width: 120 },
    { field: 'account', headerName: 'Account', width: 100 },
    { field: 'csa', headerName: 'CSA', width: 70 },
    { field: 'breed', headerName: 'Breed', width: 80 },
    { field: 'donor', headerName: 'Donor', width: 180 },
    { field: 'sire', headerName: 'Sire', width: 180 },
    { field: 'semenType', headerName: 'Semen Type', width: 90 },
    { field: 'donorLocation', headerName: 'Donor Location', width: 140 },
    { field: 'programName', headerName: 'Program Name', width: 120 },
    { field: 'fertSite', headerName: 'Fert Site', width: 110 },
    { field: 'pooled', headerName: 'Pooled', width: 90 },
    {
      field: 'export',
      headerName: 'Export',
      width: 90,
      cellStyle: (params) => {
        return params.value !== 'No' ? { backgroundColor: '#FFCCCB' } : null;
      },
    },
    { field: 'medTotal', headerName: 'Med/Total', width: 110 },
    { field: 'totalOocytes', headerName: 'Total Oocytes', width: 110 },
    { field: 'numInMat', headerName: '# in Mat', width: 80 },
    { field: 'csr', headerName: 'CSR', width: 80 },
    { field: 'matTime', headerName: 'Mat Time', width: 80 },
    { field: 'aspComments', headerName: 'Aspiration Comments', width: 200 },
    { field: 'poolNum', headerName: 'Pool Num', width: 110 },
    {
      field: 'dsAspirationComment',
      headerName: 'DS Aspiration Comment',
      width: 110,
    },
    {
      field: 'embCompleteOrder',
      hide: true,
      sortable: true,
      sort: 'asc',
    },
  ], [aspirationSelectColumnStayAtFront]);
};

export const embGridColumnDefs: ColDef[] = [
  { field: 'aspDate', headerName: 'Date', width: 100 },
  { field: 'sched', headerName: 'Schedule', width: 100 },
  { field: 'follS', headerName: 'S', width: 50 },
  { field: 'follM', headerName: 'M', width: 50 },
  { field: 'follL', headerName: 'L', width: 50 },
  { field: 'gradeAbc', headerName: 'Grades (ABC)', width: 90 },
  { field: 'gradeD', headerName: 'Grade D', width: 90 },
  { field: 'gradeE', headerName: 'Grade E', width: 90 },
  { field: 'follicles', headerName: 'Follicles', width: 100 },
  { field: 'oocytes', headerName: 'Oocytes', width: 100 },
  { field: 'sire', headerName: 'Sire', width: 180 },
  { field: 'fert', headerName: 'Fert', width: 90 },
  { field: 'clv', headerName: 'Cleaved', width: 100 },
  { field: 'viable', headerName: 'Viable', width: 90 },
];

export const donorCommentsColDefs: ColDef[] = [
  {
    headerName: 'Aspiration Comment',
    field: 'aspirationComment',
    width: 300,
  },
  { headerName: 'Donor Comment', field: 'donorComment', minWidth: 200 },
  { headerName: 'Procedure Time Comment', field: 'ptComment', width: 300 },
];
